import Phaser from "phaser";
import { GameConstants } from "../GameConstants";

export interface Layout {
    width: number;
    height: number;
    landscape: boolean;
}

export function inferIsLandscapeLayout(): boolean {
    const userAgent = navigator.userAgent || "";
    const platform = navigator.platform || "";
    const isTouchMac = /MacIntel/.test(platform) && navigator.maxTouchPoints > 2;
    const hasTouchPoints = typeof navigator.maxTouchPoints === "number" && navigator.maxTouchPoints > 0;
    const isCoarsePointer = window.matchMedia?.("(pointer: coarse)").matches ?? false;
    const hasFinePointer = (window.matchMedia?.("(pointer: fine)").matches
        || window.matchMedia?.("(any-pointer: fine)").matches) ?? false;
    const canHover = (window.matchMedia?.("(hover: hover)").matches
        || window.matchMedia?.("(any-hover: hover)").matches) ?? false;
    const isMobileUserAgent = /Android|iPhone|iPad|iPod|Windows Phone|Mobile/i.test(userAgent);
    const isDesktopPlatform = /Win32|Win64|Windows|MacIntel|MacPPC|Mac68K|Linux x86_64|Linux armv/i.test(platform);
    if (isDesktopPlatform && !isMobileUserAgent && (hasFinePointer || canHover)) return true;
    return !hasTouchPoints && !isTouchMac && !isCoarsePointer;
}

export function viewportLayout(landscape: boolean): Layout {
    const width = landscape ? GameConstants.GAME_WIDTH_LANDSCAPE : GameConstants.GAME_WIDTH_PORTRAIT;
    const height = landscape ? GameConstants.GAME_HEIGHT_LANDSCAPE
        : window.innerWidth >= window.innerHeight ? GameConstants.GAME_HEIGHT_PORTRAIT
        : width * window.innerHeight / window.innerWidth;
    return { width, height, landscape };
}

export function fitLayout(scene: Phaser.Scene, root: Phaser.GameObjects.Container): Layout {
    const { width, height } = scene.scale;
    root.setScale(1).setPosition(0, 0);
    return { width, height, landscape: width >= height };
}

export function addBackground(scene: Phaser.Scene, key: string, width: number, height: number): Phaser.GameObjects.Image {
    const image = new Phaser.GameObjects.Image(scene, width / 2, height / 2, key);
    image.setScale(Math.max(width / image.width, height / image.height));
    return image;
}

export function label(
    scene: Phaser.Scene, parent: Phaser.GameObjects.Container, x: number, y: number,
    text: string, size = 28
): Phaser.GameObjects.Text {
    const item = new Phaser.GameObjects.Text(scene, x, y, text, {
        fontFamily: "NunitoSans", fontSize: `${size}px`, color: GameConstants.TEXT_COLOR, align: "center",
        stroke: "#03142e", strokeThickness: 2
    }).setOrigin(.5);
    parent.add(item);
    return item;
}

export function button(
    scene: Phaser.Scene, parent: Phaser.GameObjects.Container, x: number, y: number,
    text: string, onClick: () => void, width = 210, enabled = true
): Phaser.GameObjects.Container {
    const item = new Phaser.GameObjects.Container(scene, x, y);
    const bg = new Phaser.GameObjects.Graphics(scene);
    bg.fillStyle(enabled ? 0x174c60 : 0x273b4d, .98);
    bg.fillRoundedRect(-width / 2, -27, width, 54, 12);
    bg.lineStyle(2, enabled ? 0x6cc9ce : 0x506273);
    bg.strokeRoundedRect(-width / 2, -27, width, 54, 12);
    item.add(bg);
    label(scene, item, 0, 0, text, 25);
    parent.add(item);
    if (enabled) {
        item.setInteractive({
            hitArea: new Phaser.Geom.Rectangle(-width / 2, -27, width, 54),
            hitAreaCallback: Phaser.Geom.Rectangle.Contains, useHandCursor: true
        });
        item.on("pointerover", () => item.setAlpha(.8));
        item.on("pointerout", () => item.setAlpha(1));
        item.on("pointerup", onClick);
    }
    return item;
}
